import { render, staticRenderFns } from "./MainFooterChad.vue?vue&type=template&id=be11f518&"
import script from "./MainFooterChad.vue?vue&type=script&lang=js&"
export * from "./MainFooterChad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports